module.exports = __webpack_public_path__ + "img/support-secure.92bdd599.svg";